export default { sha: '1f0a03e71978563b5439d9bed1aa30ca90bce6b2', buildNumber: 'undefined' }
